export default function(num, defaultValue) {
    if (typeof defaultValue == 'undefined') {
        defaultValue = 0;
    }
    if (typeof num == 'string' && num == '') {
        return defaultValue;
    }
    if (typeof num !== 'number' && typeof num == 'string') {
        num = parseFloat(num.replace(/[^0-9.]/g, ""));
    }
    if (num === '' || isNaN(num)) {
        return defaultValue;
    }
    if (num < 0) {
        return 0;
    }

    return num;
}